<template>
    <v-content>
        <div class="wedrive-bg-header-container"></div>
        <v-row v-if="isLoading" cols="12" justify="center">
            <v-col class="mx-auto" cols="12">
                <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
            </v-col>
        </v-row>
        
        <v-row v-if="!isLoading" cols="12" justify="center" class="wedrive-header-search-container fixNotchPaddingTop">
            <v-text-field 
                light solo flat
                class="search"
                style="border-radius: 10px; width: 100%; padding: 0 12px; margin-bottom: 0;"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('home.search')"/>
        </v-row>

        <v-row v-if="!isLoading" cols="12" justify="center" class="wedrive-card-sensors-container fixNotchPaddingTop">
            <v-col cols="12" sm="6" md="6" style="padding: 5px 12px;" v-for="item in filteredData" :key="item.idMobile + '-' + item.idFleet">
                <v-card class="mx-auto card-wedrives-home" min-width="300" @click="selectItem(item)">
                    <v-card-text style="padding: 15px 16px 5px;">
                        <v-row>
                            <v-col style="padding: 0 12px;">
                                <v-icon :color="item.stateDesc ? Object.entries(item.stateDesc[0]).length == 0 || 
                                    item.stateDesc[0].endsWith('OFF') ? '#000' : '#009937' : '#000'" class="wedrive-alias-mobile-icon">mdi-truck</v-icon>
                                <h2 class="wedrive-alias-mobile">
                                    {{ item.aliasMobile[0] }}
                                </h2>
                                <span class="wedrive-local-date">
                                    {{ formatLocalDateTime(parseInt(item.timestamp)) }}
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col style="padding: 0 12px;">
                                <h3 class="wedrive-short-location">
                                    {{ formatShortLocation(item.fractal[0]) }}</h3>
                            </v-col>
                        </v-row>
                        
                            <v-row cols="12" style="margin: 10px 0 0 0; border-bottom: 1px solid #e5e5e5; text-align: center;">
                                <v-col sm="6" style="border-left: 1 solid #c01033;">
                                    <span class="sensor-title">{{ $t('home.sensor-1') }}</span>
                                    <span class="sensor-value">{{ formatTemperature(item.temp1) }}</span>
                                </v-col>
                                <v-col sm="6" style="border-left: 1px solid #e5e5e5;">
                                    <span class="sensor-title">{{ $t('home.sensor-2') }}</span>
                                    <span class="sensor-value">{{ formatTemperature(item.temp2) }}</span>
                                </v-col>
                            </v-row>
                                
                            <v-row cols="12" style="margin: 0; text-align: center;">
                                <v-col sm="6">
                                    <span class="sensor-title">{{ $t('home.sensor-3') }}</span>
                                    <span class="sensor-value">{{ formatTemperature(item.temp3) }}</span>
                                </v-col>
                                <v-col sm="6" style="border-left: 1px solid #e5e5e5;">
                                    <span class="sensor-title">{{ $t('home.sensor-4') }}</span>
                                    <span class="sensor-value">{{ formatTemperature(item.temp4) }}</span>
                                </v-col>
                            </v-row>
                            <v-row cols="12" style="margin: 0; padding: 0;">
                                <v-col cols="12" class="mx-auto" style="margin: 0; padding: 10px 0 5px 0; color: #989898; text-align: center;">
                                    <v-icon color="#989898" style="top: -3px; margin-right: 5px;">mdi-update</v-icon>
                                    <span>{{ $t('app.last-measurement') }}: {{ formatLocalDateTime(parseInt(item.lastTemp)) }}</span>
                                </v-col>
                            </v-row>
                       
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-btn  dark fixed bottom right fab color="secondary" :loading="isLoading" @click="doRefresh()">
            <v-icon dark>mdi-autorenew</v-icon>
        </v-btn>

        <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                {{ alertText }}
                <v-btn text @click="showAlert=false">
									{{ $t('app.buttons.close') }}
                </v-btn>
        </v-snackbar>
        <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-content>
</template>


<script>
import BaseModule from "../../common/BaseModule"; 

export default {
    name: "HomeMain",
    mixins: [ BaseModule ],
    components: {},
    data() {
        return {
            search: '',
            isLoading: false,
            showAlert: false,
            alertColor: 'error',
            alertText: '',
            alertTimeout: 3000,
        };
    },
    computed: {
        filteredData() {
            if (!this.$store.state.wedrive.mobileData || this.$store.state.wedrive.mobileData.length == 0) {
                return [];
            }
            
            var me = this;

            return this.$store.state.wedrive.mobileData.filter(mobileData => {
                let regex = new RegExp('(' + me.search + ')', 'i');
                return mobileData.aliasMobile[0].match(regex);
            });
        },
    },
    methods: {
        doShowAlert: function(payload) {
            this.alertText = payload.text;
            this.alertColor = payload.color;
            this.alertTimeout = payload.timeout;
            this.showAlert = true;
        },
        selectItem: function (item) {
            this.$router.push({ name: 'detail', params: { idFleet: item.idFleet, idMobile: item.idMobile } });
        },
        doRefresh: function() {
            this.isLoading = true;
            
            this.updateMobileData(
            () => {
                this.isLoading = false;
            }, 
            (error) => {
                this.isLoading = false;
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        },
    },
     mounted: function() { 
        window.$vue.$off('ne_backbutton');
    },  
    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
            this.doRefresh();
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('wedrive/setNavTitle', null);
            vm.$store.commit('wedrive/setShowLastUpdate', true);
            if (from.path === '/') {
                vm.doRefresh();
            }
        });
    }
};
</script>